import { useRouter } from 'next/router';

import { useMediaQuery, Grid, Pagination } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { EmptyState } from '@/src/components/organisms';

import CardBlog from './CardBlog';

const useStyles = makeStyles(theme => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 400,
      margin: '0 auto',
    },
  },
}));

function Results({ data }) {
  const router = useRouter();
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), { defaultMatches: true });

  const { results = [], page: currentPage = 1, total_pages: totalPages = 1 } = data || {};
  const { search = '' } = router.query;

  const handlePageChange = (_, value) =>
    router.push({ pathname: '', query: { search, page: value } }, undefined, {
      shallow: true,
      scroll: true,
    });

  if (results.length === 0) {
    return (
      <div className={classes.root}>
        <EmptyState
          subtitle={
            router.query.search
              ? `Nenhum artigo com o termo '${router.query.search}'`
              : 'Nenhum artigo encontrado para ser exibido'
          }
          ButtonProps={{ onClick: () => router.back() }}
        />
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Grid container spacing={isMd ? 4 : 2}>
        {results?.map(post => (
          <CardBlog
            key={post.uid}
            title={post.data.title}
            description={post.data.description}
            cover={post.data.cover}
            date={post.data.date}
            author={post.data.author.data}
            href={['/blog/post', post.uid].join('/')}
          />
        ))}
        {totalPages > 1 && (
          <Grid item container xs={12} data-aos="fade-up" justifyContent="center">
            <Pagination
              count={totalPages}
              page={currentPage}
              color="primary"
              size="large"
              shape="rounded"
              onChange={handlePageChange}
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
}

Results.propTypes = {
  data: PropTypes.object,
};

export default Results;
